import { cn } from "@mindstonehq/ui";

export function PageColumn(
  props: React.PropsWithChildren<{ className?: string }>,
) {
  return (
    <div
      className={cn(
        "gap-4 sm:gap-5 lg:gap-6 2xl:gap-8 flex flex-col overflow-y-auto",
        props.className,
      )}
    >
      {props.children}
    </div>
  );
}
